import BaseAnalytics from "app/core/analytics";

class Analytics {
    constructor() {
        /**
         * @property analytics
         * @type {Object}
         */
        this.analytics = BaseAnalytics.getInstance();

        /**
         * @property eventActions
         * @type {Object}
         */
        this.event = {
            addFavorite: "add_favorite"
        };
    }

    /**
     * @public
     * @method selectedFavorite
     * @param item
     */
    selectedFavorite(item) {
        try {
            this.analytics.sendGoogleAnalyticsEvent("", item.entity.alias, "all", this.event.addFavorite);
        } catch (e) {
            console.log(e);
        }
    }
}

export default Analytics;
